export default __webpack_public_path__ + "static/media/benefit_7@3x.4982ac1e.png";